"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagCX = function FlagCX(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M214,144.65-190.4-120.29a7,7,0,0,1,4.46-1.71H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7,7,0,0,1-2.6,5.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M54.17,12.18A42.37,42.37,0,1,1,11.8-30.19,42.37,42.37,0,0,1,54.17,12.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-162.11,12.66l2.45,6.21,6.39-2a.41.41,0,0,1,.47.6l-3.32,5.78,5.5,3.78a.4.4,0,0,1-.17.73l-6.6,1,.49,6.66a.41.41,0,0,1-.69.33l-4.9-4.53-4.9,4.53a.41.41,0,0,1-.68-.33l.48-6.66-6.6-1a.4.4,0,0,1-.17-.73l5.51-3.78-3.33-5.78a.41.41,0,0,1,.48-.6l6.38,2,2.45-6.21a.41.41,0,0,1,.76,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-72.85-4.08l2.45,6.21L-64,.18a.41.41,0,0,1,.47.59l-3.32,5.79,5.5,3.77a.41.41,0,0,1-.17.74l-6.59,1,.48,6.65a.41.41,0,0,1-.68.34l-4.91-4.53-4.9,4.53a.41.41,0,0,1-.68-.34l.48-6.65-6.6-1a.41.41,0,0,1-.16-.74l5.5-3.77L-82.91.77a.4.4,0,0,1,.47-.59l6.38,2,2.45-6.21a.41.41,0,0,1,.76,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-117.48-44.33l2.45,6.21,6.38-2a.41.41,0,0,1,.48.59l-3.33,5.79,5.51,3.77a.41.41,0,0,1-.17.74l-6.6,1,.49,6.66a.41.41,0,0,1-.69.33l-4.9-4.53-4.9,4.53a.41.41,0,0,1-.69-.33l.49-6.66-6.6-1a.41.41,0,0,1-.17-.74l5.51-3.77-3.33-5.79a.41.41,0,0,1,.48-.59l6.38,2,2.45-6.21a.41.41,0,0,1,.76,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-117.48,101.92l2.45,6.21,6.38-2a.41.41,0,0,1,.48.6l-3.33,5.78,5.51,3.78a.41.41,0,0,1-.17.74l-6.6,1,.49,6.65a.41.41,0,0,1-.69.33l-4.9-4.52-4.9,4.52a.41.41,0,0,1-.69-.33l.49-6.65-6.6-1a.41.41,0,0,1-.17-.74l5.51-3.78-3.33-5.78a.42.42,0,0,1,.48-.6l6.38,2,2.45-6.21a.41.41,0,0,1,.76,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-99.21,18.27l1.71,5.14,5.41,0a.43.43,0,0,1,.26.78l-4.35,3.22,1.62,5.15a.43.43,0,0,1-.66.49L-99.62,30l-4.4,3.14a.44.44,0,0,1-.67-.49l1.63-5.15-4.35-3.22a.43.43,0,0,1,.25-.78l5.41,0,1.71-5.14a.44.44,0,0,1,.83,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-13.34-6c-1.73-.4-3.48,4.05-1.55,5.6S-9.48,4-11.6,5.73s-2.9,1.93-3.29,4,0,2.51-1.73,3.47-5.79,2.9-4.06,4.83,4.06.78,5.6-2.31c0,0,10.81-.39,11.2.38s1.35,3.67,3.66,2.9l2.32-.78a2.06,2.06,0,0,1,2.32.58c1,1.16,3.28,1.54,6,1.54s5,1.55,4.83,5.22c-.13,2.35-.73,7.23-1.14,10.44a3.21,3.21,0,0,0,2.66,3.58l4.95.83a2.25,2.25,0,0,0,2.62-2c.23-2.64.57-6.51.56-6.64-.11-1.39,2.7-8.5,2.51-11.78l-.19-3.28s2.89-.39,4.05-2.32,3.67-6.75,8.69-8.49l1.35-3.28S37.43.9,38.2-.26,39.35-4.5,38.78-7A43.6,43.6,0,0,1,38-13s-1.37-.58-1.66.22-.58,1.24-1.31,1.09-1.82-.22-2.11-.87-1.09-1.31-1.82-.94-2,5.23-3.7,5.73c0,0-.15-2.1-1.24-1.66S25.15-8,25-6.16,12.65,7.93,2,4.66A3.88,3.88,0,0,0-1.59,2.55C-4,2.77-6.32,2.7-7.7,1S-11.28-5.57-13.34-6Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M65.27,14.14c3.22,3.43,38.59,13.06,74.34-5.67s57-24.12,57-24.12.28-4.82,4.68-5.53,2.27-2.55,1.14-4-6.67-5.24-14.19-2c0,0-8.75.33-10.07-11.78s-1.9-24.4-4.92-29.7-28-31.78-31-29.7,7.57,28.38,17.41,37.65c0,0,2.27,16.27-.57,17s-18.54-13.63-46.54-17c0,0,11.92,16.27,26.49,23.08s18.54,13.05,18.16,15.7S151.91-6.57,143.78-.7,115.21,21.05,68.86,12.73c0,0-5.1-.19-3.59,1.41Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagCX;
exports["default"] = _default;